import React, { useEffect, useState } from 'react';
import Table from '../../components/tables/Table';
import Pagination from '../../components/tables/pagination/Pagination';
import CustomLoading from '../../components/customLoading/CustomLoading';
import { toast } from 'react-toastify';
import { getFpoEnquiries, getFpoSummary } from '../../services/enquiries';
import { formatDateTime } from '../../utils/FormatDateTime';
import { BiNotepad } from 'react-icons/bi';
import ShowModal from '../../utils/ShowModal';
import AddFpoNote from './AddFpoNote';

function FpoEnquiries() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const headers = [
        { label: "S. No.", key: "sno" },
        { label: "Time", key: "created_at" },
        { label: "Name", key: "farmer_name" },
        { label: "Phone", key: "farmer_number" },
        { label: "Message", key: "message" },
        { label: "Platform", key: "enquiry_from" },
        { label: "Note", key: "note" },
    ];

    const pageSize = 50;

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getFpoEnquiries(query);
            if (res.status === 200) {
                const data = res.data;
                setData(data)
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData("");
    }, []);
    const [modalIsOpen, setIsOpen] = useState(false);
    const [openingItem, setOpeningItem] = useState({});

    // Open modal with the selected PDF ID
    const openModal = (item) => {
        setOpeningItem(item);
        setIsOpen(true);
    };

    // Close modal
    const closeModal = () => {
        setIsOpen(false);
        setOpeningItem({});
    };

    const onSave = () => {
        fetchData();
        closeModal();
    };
    return (<>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={data?.results?.map((item, index) => (
                            {
                                sno: <p className={`rounded-full text-center font-bold text-white ${item.note && item.note.length !== 0 ? "bg-primary" : "bg-red-700"}`} > {index + 1}</p>,
                                farmer_name: <p>{item.farmer_name}</p>,
                                created_at: <p>{formatDateTime(item.created_at)}</p>,
                                enquiry_from: <p>{item.enquiry_from}</p>,
                                message: <p className="max-w-48 truncate cursor-help" title={item.message}>{item.message}</p>,
                                farmer_number: <p>{item.farmer_mobile}</p>,
                                note: <BiNotepad size={24} color='green' onClick={() => openModal(item)} className='cursor-pointer' />,
                            }))}
                    />
                </div>}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            data.count !== 0 ?
                <Pagination
                    currentPage={currentPage}

                    pageSize={pageSize}
                    totalEntries={data?.count}
                    onPageChange={handlePageChange}
                    data={data}
                    setData={setData}
                /> : <></>
        }
        <ShowModal contentLabel={"Note alert"} isOpen={modalIsOpen} modalWidth="50%" isSidebar={true} onRequestClose={closeModal} componentToPass={<AddFpoNote item={openingItem} onSave={onSave} />} />
    </>);
}

export default FpoEnquiries;